"use client";

import React, {FC, useEffect, useState} from "react";
import {useUser} from "@/shared/lib/UserContext";
import {ClientSearchModal} from "../ClientSearchModal";
import {ClientCRM, OrderFormData, VehicleType} from "@/features/types/StatusChangeInterface";
import {Row} from "@tanstack/react-table";
import {AutoTableInterface} from "@/features/types/AutoTableInterface";
import {ModalSection} from "@/shared/components/ModalSection";
import {getOrderActionContentSections} from "./OrderActionContent.data";

export interface OrderActionContentProps {
    row: Row<AutoTableInterface>;
    onDataChange?: (data: OrderFormData) => void;
}

export const OrderActionContent: FC<OrderActionContentProps> = ({row, onDataChange}) => {
    const {userName, loading: userNameLoading} = useUser();
    const [client, setClient] = useState<ClientCRM | null>(null);
    const [showClientSearch, setShowClientSearch] = useState(false);
    const [ord_sales_agr_issue_dat, setOrdSalesAgrIssueDat] = useState<Date | null>(new Date());
    const [ord_sales_agr_registr_dat, setOrdSalesAgrRegistrDat] = useState<Date | null>(new Date());
    const [ord_vehicle_type, setOrdVehicleType] = useState<VehicleType | null>(null);
    const [ord_sales_price, setOrdSalesPrice] = useState<string>("");

    const handleClientSelect = (selectedClient: ClientCRM) => {
        setClient(selectedClient);
    };

    // Aktualizuj dane w rodzicu przy każdej zmianie
    useEffect(() => {
        onDataChange?.({
            client,
            ord_vehicle_type,
            ord_sales_agr_issue_dat,
            ord_sales_agr_registr_dat,
            ord_sales_price,
        });
    }, [client, ord_vehicle_type, ord_sales_agr_issue_dat, ord_sales_agr_registr_dat, ord_sales_price, onDataChange]);

    const sections = getOrderActionContentSections({
        row,
        client,
        onShowClientSearch: () => setShowClientSearch(true),
        ord_vehicle_type,
        onVehicleTypeChange: setOrdVehicleType,
        ord_sales_agr_issue_dat,
        onIssueDateChange: setOrdSalesAgrIssueDat,
        ord_sales_agr_registr_dat,
        onRegistrDateChange: setOrdSalesAgrRegistrDat,
        ord_sales_price,
        onSalesPriceChange: setOrdSalesPrice,
    });

    return (
        <>
            <ClientSearchModal
                isOpen={showClientSearch}
                onClose={() => setShowClientSearch(false)}
                onSelect={handleClientSelect}
            />

            {/* Użytkownik - poza ModalSection */}
            <div className="mb-2 text-xs lg:text-sm flex justify-start gap-1">
                <span className="font-medium">Użytkownik: </span>
                <span>{userNameLoading ? "Ładowanie..." : (userName || "Brak danych")}</span>
            </div>

            <ModalSection items={sections} />
        </>
    );
};

